import VueI18n from 'vue-i18n'
import Vue from 'vue'
import en from "./lang/en_US";
import zh from "./lang/zh_CN";
Vue.use(VueI18n)
// 2、创建英文语言包对象

const messages = {
  zh,
  en
}
let lang = localStorage.getItem('lang')||navigator.language.split('-')[0]

const i18n = new VueI18n({
  messages,
  locale: lang
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js